// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSPromotionSearchScope;
(function (TCSPromotionSearchScope) {
    TCSPromotionSearchScope[TCSPromotionSearchScope["Brand"] = 0] = "Brand";
    TCSPromotionSearchScope[TCSPromotionSearchScope["ProgramId"] = 1] = "ProgramId";
    TCSPromotionSearchScope[TCSPromotionSearchScope["PromotionGroup"] = 2] = "PromotionGroup";
})(TCSPromotionSearchScope || (TCSPromotionSearchScope = {}));
//# sourceMappingURL=tCSPromotionSearchScope.js.map